export default "__VITE_ASSET__BQLMWIqQ__"